import { useLocalObservable } from "mobx-react-lite";
import { ChartStore, ChartStoreConfig, ChartType } from "@/stores/ui/Chart";

interface UseChartStoreConfig {
	structureId: Dryp.StructureId;
	defaultType?: ChartType;
	height?: number;
}

export function useChartStore(config: UseChartStoreConfig) {
	const fullConfig: ChartStoreConfig = {
		...config,
	};
	const store = useLocalObservable(() => new ChartStore(fullConfig));
	return store;
}
